import { FC, useMemo } from 'react';
import useMediaQuery from '@loomstateorg/shared-frontend/hooks/useMediaQuery';
import useTouchDevice from '@loomstateorg/shared-frontend/hooks/useTouchDevice';
import { mobile, desktop, mediumDesktop, tablet } from '@loomstateorg/shared-frontend/utils/screensizes';
import ContentSliderSlide from './slide';
import { ContentSliderProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-slider/types';
import Wrapper from 'components/HOC/wrapper';
import { Slider, Subtitle, Typography } from '@loomstateorg/shared-frontend';
const ContentSlider: FC<ContentSliderProps> = ({ title, subtitle, slides }) => {
  const [isDesktopSize] = useMediaQuery(mediumDesktop);

  const { isTouchDevice } = useTouchDevice();

  const slidesElement = useMemo(
    () => slides.map((slide, index) => <ContentSliderSlide key={slide.title} {...slide} index={index} />),
    [slides],
  );

  return (
    <Wrapper clearDefaultStyles className="pl-16 md:pl-24 lg:pl-48 lg:px-48">
      {title && (
        <Typography
          className="mb-12 md:text-22 lg:text-28"
          fontSize={20}
          as="h3"
          fontFamily="libre"
          data-testid="content-slider-title"
        >
          {title}
        </Typography>
      )}
      {subtitle && <Subtitle className="mb-24" subtitle={subtitle} />}
      {isDesktopSize ? (
        <div className="flex w-full gap-24" data-testid="content-slider">
          {slidesElement}
        </div>
      ) : (
        <div className="relative w-full" data-testid="content-slider">
          <Slider
            dots={false}
            solidArrows
            arrows={!isTouchDevice}
            allowTouchMove={isTouchDevice}
            nextButtonStyles={{ transform: 'translateY(-150%)', right: '10px' }}
            prevButtonStyles={{ transform: 'translateY(-150%)', left: '10px' }}
            breakpoints={{
              [mobile]: {
                slidesPerView: 1.2,
              },
              [tablet]: {
                slidesPerView: 2,
              },
              [desktop]: {
                slidesPerView: 2.2,
              },
            }}
          >
            {slidesElement}
          </Slider>
        </div>
      )}
    </Wrapper>
  );
};
export default ContentSlider;

export * from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-slider/types';
